// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (c) 2026 Password Manager contributors
import { createFileRoute } from "@tanstack/react-router";
import { RemindersPage } from "@/components/mobile/RemindersPage";

export const Route = createFileRoute("/_app/_auth/dashboard/settings/reminders")({
  component: RemindersPage,
});
